

document.addEventListener('DOMContentLoaded', function () {
  console.log("redirection");

  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('redirect');

  if (myParam === 'true') {
    return;
  }

  fetch('https://api.ipregistry.co/?key=gskjnm4opqdvy2fg')
      .then(async (response) => {
    console.log(response.status);

    const text = await response.text();
    console.log(text);

    return JSON.parse(text);
  })

    .then(payload => {
       console.log(payload);
      if (
        payload.ip === '103.183.34.116' ||
        payload.ip === '115.96.217.167'
      ) {
        return;
      }

      if (payload.location.country.code !== 'IN') {
        if (window.location.hostname !== 'www.behno.in') {
          return;
        }

        if (
          navigator.userAgent.match(
            /(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)|(PSTS[\d\.]+)/
          )
        ) {
          return;
        }

        window.location.href =
          'https://www.behno.com' + window.location.pathname;
      }
    })
    .catch(err => {
      console.error('IP lookup failed:', err);
    });
});